
export const pricing = {
    // Page title and subtitle
    chooseYourPlan: '选择您的方案',
    selectPerfectPlan: '选择最适合您创意需求的完美方案',
    
    // Billing cycle
    yearly: '年付',
    monthly: '月付',
    year: '年',
    month: '月',
    pack: '包',
    
    // Credit packs
    creditPacks: '积分包',
    
    // Plan status
    mostPopular: '最受欢迎',
    currentPlan: '当前方案',
    
    // Actions
    buyNow: '立即购买',
    subscribe: '订阅',
    subscribeStarter: '订阅入门版',
    subscribePro: '订阅专业版',
    subscribePremium: '订阅高级版',
    subscribeNow: '立即订阅',
    processing: '处理中...',
    retry: '重试',
    cryptoPayment: '加密货币支付',
    
    // Loading states
    loading: '正在加载定价方案...',
    unableToLoadPlans: '无法加载定价方案',
    noPlansAvailable: '暂无可用方案',
    noPlansMessage: '目前没有可用的{billingCycle}方案。',
    
    // Security and help
    securePayment: '由 Stripe 提供的安全支付',
    needHelp: '需要帮助？联系我们的支持团队',
    
    // FAQ
    faqTitle: '常见问题',
    faqSubtitle: '找到关于我们定价和方案的常见问题答案',
    
    faq1Question: '我可以随时更改方案吗？',
    faq1Answer: '是的，您可以随时升级或降级您的方案。更改将在下一个计费周期生效。',
    
    faq2Question: '您接受哪些付款方式？',
    faq2Answer: '我们通过安全的 Stripe 集成接受所有主要信用卡、PayPal 和其他付款方式。',
    
    faq3Question: '有免费试用吗？',
    faq3Answer: '是的，所有新用户注册后都会收到免费积分来试用我们的服务。',
    
    faq4Question: '我可以随时取消订阅吗？',
    faq4Answer: '是的，您可以随时取消订阅。您将继续享有服务直到当前计费周期结束。',
    
    faq5Question: '未使用的积分会结转吗？',
    faq5Answer: '订阅方案的积分会在每个计费周期结束时清零，不会结转到下个月。但购买的积分包积分永久有效，不会过期。',
    
    faq6Question: '年度方案有折扣吗？',
    faq6Answer: '是的，年度方案相比月度计费提供显著节省。折扣会自动应用。'
  };
